import { window } from '../globals';
import ErrorLogger from '../error-logger/ErrorLogger';

const statsigServiceLazy = async () => import('./StatsigService');

const experiment =
  window?.siteMetadata?.experimentFlag ||
  window?.CHECKOUT_STATE?.contextData?.experimentFlag ||
  window?.ALGOLIA_GLOBAL_SEARCH_DATA?.contextData?.experimentFlag;

const experimentVariation =
  window?.siteMetadata?.experimentVariation ||
  window?.CHECKOUT_STATE?.contextData?.experimentVariation ||
  window?.ALGOLIA_GLOBAL_SEARCH_DATA?.contextData?.experimentVariation;

if (experiment && experimentVariation && navigator.cookieEnabled) {
  statsigServiceLazy()
    .then(async (statsigService) => {
      await statsigService.default
        .init(experiment, experimentVariation)
        .catch((e: Error) => ErrorLogger.createFromGlobals()?.log(e));
    })
    .catch((e: Error) => {
      ErrorLogger.createFromGlobals()?.log(e);
    });
}
